<template>
	<wt-selector :options="options" v-model="Value" :clearable="true"></wt-selector>
</template>
<script>
import { posterType } from 'json/index'
export default {
  name: 'lab-order-status-selector',
  props: {
    value: {
      type: String
    }
  },
  data () {
    return {
      Value: this.value ? this.value : '',
      options: posterType
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  }
}
</script>
